import { createAction, props } from '@ngrx/store';

export const
    setActiveIntegrations = createAction('[Organization] setActiveIntegrations', props<{
        activeIntegrations: Record<string, { data: string }>
    }>());
